import ButtonBase from '@bugbug/core/components/Button';
import styled from 'styled-components';

import boltSrc from '~/images/bolt.png';
import { OnboardingSubtitle, OnboardingTitle } from '~/views/Onboarding/Onboarding.styled';

export const Title = styled(OnboardingTitle)`
  font-size: 24px;
`;

export const Subtitle = styled(OnboardingSubtitle)`
  font-size: 16px;
  max-width: 340px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 380px;
  gap: 4px;
`;

export const PlansContainer = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  min-height: 380px;
  margin-top: 46px;
  margin-bottom: 55px;
`;

export const BoltImage = styled.img.attrs(() => ({
  src: boltSrc,
}))`
  width: 80px;
  height: 80px;
  margin-bottom: 18px;
`;

export const Footer = styled.div`
  font-size: 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  p {
    margin: 0;
  }
`;

export const Plan = styled.div`
  border-radius: 8px;
  border: 3px solid ${({ theme }) => theme.colors.border.semi};
  padding: 20px;
  min-height: 400px;
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
`;

export const Ribbon = styled.div`
  position: absolute;
  top: 22px;
  right: -49px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  font-size: 13px;
  line-height: 37px;
  color: ${(props) => props.theme.colors.common.white};
  font-weight: ${(props) => props.theme.fontWeight.bold};
  background-color: ${(props) => props.theme.colors.accent};
  transform: rotate(45deg);
  text-transform: uppercase;
  width: 180px;
`;

export const PlanName = styled.p`
  margin: 0;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.primary};
  font-size: 16px;
`;

export const PlanPerk = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  font-size: 14px;
`;

export const PlanPerksContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PlanButton = styled(ButtonBase)`
  margin: 0;
  margin-top: auto;
  margin-bottom: 14px;
  width: 100%;

  div {
    max-width: fit-content;
  }
`;

export const PlanPrice = styled.p`
  margin-top: 4px;
  margin-bottom: 24px;
`;
